import { Box } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type ListProps = StructuredContentDocument<{
  ordered?: boolean;
  children: StructuredContentDocument;
}>;

export const List = ({ props }: ListProps) => {
  return (
    <Box
      component={props.ordered ? 'ol' : 'ul'}
      sx={{ paddingLeft: 0, ...(!props.ordered && { listStyle: 'none' }) }}
    >
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
};
